var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTextHThree = function SvgIconTextHThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5.25a1 1 0 0 0-2 0V16.5a1 1 0 1 0 2 0v-4.625h7.75V16.5a1 1 0 1 0 2 0V5.25a1 1 0 1 0-2 0v4.625H4.75zM18 9.125a1 1 0 1 0 0 2h2.58l-1.524 2.177a1 1 0 0 0 .819 1.573 1.624 1.624 0 1 1-1.15 2.774 1 1 0 1 0-1.413 1.414 3.624 3.624 0 1 0 4.208-5.793l1.8-2.572a1 1 0 0 0-.82-1.573z"
  }))));
};
export default SvgIconTextHThree;